module.exports = __webpack_public_path__ + "static/media/shoppingCartIcon.624c9517.svg";